/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Company_Name_PlaceholderInputs */

const en_case_field_company_name_placeholder = /** @type {(inputs: Case_Field_Company_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal name or trade name`)
};

const pt_br2_case_field_company_name_placeholder = /** @type {(inputs: Case_Field_Company_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razão social ou nome fantasia`)
};

/**
* | output |
* | --- |
* | "Legal name or trade name" |
*
* @param {Case_Field_Company_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_company_name_placeholder = /** @type {((inputs?: Case_Field_Company_Name_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Company_Name_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_company_name_placeholder(inputs)
	return pt_br2_case_field_company_name_placeholder(inputs)
});